/* ─────────────────────────────────────────────────────────────
   PB-STANDARD-EVENTS — the two helpers this theme calls and never defines
   ───────────────────────────────────────────────────────────────

   assets/cart-discounts.js and assets/cart-notes.js both call
   publishStandardEvent() and standardEventCartFromAjax(). Neither is defined
   anywhere in the theme — confirmed by grepping the whole export, and the same
   is true of the 02 August export, so this was never a regression. The vendor
   shipped the calls without the helpers.

   What it cost: in cart-discounts.js, renderDiscounts() hides the previous error
   at line 90, calls publishStandardEvent at line 92, and only reaches its fetch
   at line 98. Pressing Apply threw a ReferenceError BEFORE the request was made
   — no code applied, no error shown, nothing in the network tab. Identical in
   the cart drawer. standardEventCartFromAjax is called inside the success
   handler, so even a fixed first helper would throw in .then and take the
   section re-render and the invalid-code error with it. Both have to exist.

   Deliberately minimal. This is not an analytics integration and does not
   pretend to be one: nothing in the theme listens for CartDiscountUpdateEvent,
   CartNoteUpdateEvent or CartErrorEvent. The job is to stop a checkout-adjacent
   control throwing on click, using the implementation the vendor already wrote.

   publishStandardEvent dispatches a DOM CustomEvent — what the name implies,
   and what gives pb-cart.js a hook: the Confirm panel must re-render when a
   discount lands, and cart-discounts.js re-renders only main-cart, cart-drawer
   and cart-bubble.

   Both are guarded, so a real implementation arriving later wins and these do
   nothing. Loaded before app.js and NOT deferred, because both callers are
   deferred — anything defined here is in place before they run.               */

if (typeof window.publishStandardEvent !== 'function') {
    window.publishStandardEvent = function (eventName, payload) {
        if (!eventName) return;
        try {
            document.dispatchEvent(new CustomEvent(eventName, { detail: payload || {} }));
        } catch (e) {
            /*  A failed dispatch must not take the caller down with it — the
                caller is part-way through applying a discount. */
        }
    };
}

if (typeof window.standardEventCartFromAjax !== 'function') {
    /*  Passes the cart through unchanged. A real version would reshape an AJAX
        cart into Shopify's standard-event payload; nothing here consumes that
        shape, and inventing one would be guessing at a contract no reader has. */
    window.standardEventCartFromAjax = function (cart) { return cart; };
}
